import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type ObservableDocumentModel from 'tio-data/models/observable-document';

type RouteParams = {
  observable_document_id: string;
};

export default class AuthenticatedObservabilityConfirmRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;

  async model(params: RouteParams) {
    const id = params['observable_document_id'];

    // fetch loan here for account information section
    const observableDocument = await this.store.findRecord('observable-document', id, {
      include: 'observable-asset,financial-institution,account-transactions,person.employees.plan',
    });

    return observableDocument;
  }

  async afterModel(model: ObservableDocumentModel) {
    if (model.subsistenceState !== 'SubsistenceState.IMPLICIT') {
      this.router.transitionTo(
        'authenticated.observability.documents.show',
        // @ts-expect-error this seems like a bug
        model.observableDocument
      );
    }
  }
}
